import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { DoBootstrap, ErrorHandler, inject, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import merge from 'lodash-es/merge';
import { initSentry } from '../../../../libs/common/resources/src/sentry';
import { GlobalErrorHandler } from '../../../../libs/common/services/src/error-handler/global-error-handler';
import { CONFIG } from '../../../../libs/essentials/types/src/mea-config';
import { IconLabelPipe } from '../../../../libs/essentials/util/src/pipes/icon-label.pipe';
import { IconNamePipe } from '../../../../libs/essentials/util/src/pipes/icon-name.pipe';
import { metaReducers } from '../../../../libs/store/src/common-store/metaReducers';
import { environment } from '../environments/environment';
import { featureFlags } from '../environments/feature-flags';
import { AppComponent } from './app.component';
import { ChatAndShopButtonComponent } from './chat-and-shop-button/chat-and-shop-button.component';
import { WidgetButtonComponent } from './chat-and-shop-button/widget-button/widget-button.component';
import { PharmacyStoreModule } from './store/pharmacy-store.module';
import { translateModuleConfig } from './webpack-translate-loader';

registerLocaleData(localeDe);

// This is set by the webpack DefinePlugin
declare let VERSION: string;

if (typeof VERSION !== 'undefined' && environment.name === 'prod') {
  initSentry({
    dsn: environment.sentryDSN,
    release: VERSION,
    environment: environment.name,
  });
}
const mergeConfigs = () => merge(environment, featureFlags);

@NgModule({
  imports: [
    BrowserModule,
    StoreModule.forRoot(
      {},
      {
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: !environment.production,
          strictActionImmutability: !environment.production,
        },
      }
    ),
    IonicModule.forRoot({
      animated: environment.animated,
      useSetInputAPI: true,
    }),
    IonicStorageModule.forRoot(),
    RouterModule.forRoot([]),
    TranslateModule.forRoot(translateModuleConfig),
    EffectsModule.forRoot([]),
    PharmacyStoreModule,
    AppComponent,
    WidgetButtonComponent,
    ChatAndShopButtonComponent,
    ...environment.imports,
  ],
  providers: [
    IconNamePipe,
    IconLabelPipe,
    provideHttpClient(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: CONFIG, useValue: mergeConfigs() },
    { provide: APP_BASE_HREF, useValue: '' },
    { provide: LOCALE_ID, useValue: 'de-de' },
    provideAnimations(),
  ],
})
export class AppModule implements DoBootstrap {
  private injector = inject(Injector);

  constructor() {
    const injector = this.injector;
    const translate = inject(TranslateService);

    translate.setDefaultLang('de');

    const el = createCustomElement(AppComponent, { injector });
    customElements.define('chat-widget', el);
  }

  ngDoBootstrap() {
    console.log('initialize chat widget');
  }
}
